import {OctTable} from "@oceantech/oceantech-ui";
import {Dispatch, SetStateAction, useContext} from "react";
import {XayDungKeHoachContext} from "../DanhSachKeHoach";
import {TypeKeHoach} from "../models/KeHoachModel";
import {formatDateToDDMMYYYY, formatMoney} from "../../../../utils/FormatUtils";
import {CODE_NHAP_KHO} from "../../../../phan-he-nhap-kho/constants/constansNhapKho";
import {CODE_KE_HOACH} from "../constants/constansKeHoach";

interface Props {
  isView?: boolean;
  indexRowEdit: number | null;
  setIndexRowEdit: Dispatch<SetStateAction<number | null>>,
  setInitialValuesFormThemVT: Dispatch<SetStateAction<any>>,
  type: TypeKeHoach,
}

const TableThongTinKyThuatChuyenGiao = (props: Props) => {
  const {isView, indexRowEdit, setIndexRowEdit, setInitialValuesFormThemVT, type} = props;
  const {dsKeHoach, setDsKeHoach} = useContext(XayDungKeHoachContext);

  const hanldeDeleteRow = (index: number) => {
    const data = [...dsKeHoach].filter((_: any, i: number) => i !== index);
    setDsKeHoach(data);
  };
  const handleEdit = (rowData: any, index: number) => {
    setInitialValuesFormThemVT({
      ...rowData?.item,
      ...rowData,
      id: rowData?.id || null,
      countryofOriginName: rowData?.countryofOriginName || rowData?.item?.countryofOriginName,
      manufacturerName: rowData?.manufacturerName || rowData?.item?.manufacturerName,
      code: rowData.code || rowData.item?.code,
      isFirstClick: true,
    });
    setIndexRowEdit(index);
  }

  const columnsNCC = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 100,
          },
          cellStyle: {
            textAlign: "center",
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              {indexRowEdit !== index && <>
                  <i
                      onClick={(e) => handleEdit(row, index)}
                      className="bi bi-pencil-square text-navy"
                  ></i>
                  <i
                      onClick={(e) => hanldeDeleteRow(index)}
                      className="bi bi-trash3-fill text-danger spaces ml-10  "
                  ></i>
              </>}
            </div>
        },
      ] : []),

    {
      name: "Kỹ thuật chuyển giao",
      field: "transferTechniqueName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.transferTechniqueName || row.item?.transferTechniqueName || '',
    },
    {
      name: "Mục tiêu chuyển giao",
      field: "transferObjective",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.transferObjective || row.item?.transferObjective || '',
    },
    {
      name: "Thời gian bắt đầu",
      field: "startTime",
      headerStyle: {
        width: 140,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => formatDateToDDMMYYYY(row?.startTime) || '',
    },
    {
      name: "Thời gian kết thúc",
      field: "endTime",
      headerStyle: {
        width: 140,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => formatDateToDDMMYYYY(row?.endTime) || '',
    },
  ];

  const columnsKH = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        minWidth: 50,
        maxWidth: 50,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 100,
          },
          cellStyle: {
            textAlign: "center",
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              {indexRowEdit !== index && <>
                  <i
                      onClick={(e) => handleEdit(row, index)}
                      className="bi bi-pencil-square text-navy"
                  ></i>
                  <i
                      onClick={(e) => hanldeDeleteRow(index)}
                      className="bi bi-trash3-fill text-danger spaces ml-10  "
                  ></i>
              </>}
            </div>
        },
      ] : []),

    {
      name: "Kỹ thuật chuyển giao",
      field: "transferTechniqueName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.transferTechniqueName || row.item?.transferTechniqueName || '',
    },
    {
      name: "Mục tiêu chuyển giao",
      field: "transferObjective",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.transferObjective || row.item?.transferObjective || '',
    },
    {
      name: "Thời gian bắt đầu",
      field: "startTime",
      headerStyle: {
        width: 140,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => formatDateToDDMMYYYY(row?.startTime) || '',
    },
    {
      name: "Thời gian kết thúc",
      field: "endTime",
      headerStyle: {
        width: 140,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => formatDateToDDMMYYYY(row?.endTime) || '',
    },
  ];

  const columnsKhac = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        minWidth: 50,
        maxWidth: 50,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 100,
          },
          cellStyle: {
            textAlign: "center",
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              {indexRowEdit !== index && <>
                  <i
                      onClick={(e) => handleEdit(row, index)}
                      className="bi bi-pencil-square text-navy"
                  ></i>
                  <i
                      onClick={(e) => hanldeDeleteRow(index)}
                      className="bi bi-trash3-fill text-danger spaces ml-10  "
                  ></i>
              </>}
            </div>
        },
      ] : []),
    {
      name: "Ca bệnh hội chẩn",
      field: "consultationName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.consultationName || row.item?.consultationName || '',
    },
    {
      name: "Mức độ hội chẩn",
      field: "consultationLevelName",
      headerStyle: {
        minWidth: 100,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.consultationLevelName || row.item?.consultationLevelName || '',

    },
    {
      name: "Đơn vị đề xuất",
      field: "recommendedUnitName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.recommendedUnitName || row.item?.recommendedUnitName || '',
    },
    {
      name: "Ngày đề xuất",
      field: "proposedDate",
      headerStyle: {
        width: 140,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => formatDateToDDMMYYYY(row?.proposedDate) || '',
    },
    {
      name: "Hình thức kết nối",
      field: "connectionFormName",
      headerStyle: {
        width: 140,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => row?.connectionFormName || '',
    },
    {
      name: "Mục tiêu hội chẩn",
      field: "consultationObject",
      headerStyle: {
        width: 140,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => row?.consultationObject || '',
    },
  ];

  const columns = {
    [CODE_KE_HOACH.KHHT]: columnsNCC,
    [CODE_KE_HOACH.KHCG]: columnsKH,
    [CODE_KE_HOACH.KHHC]: columnsKhac,
  };

  return (
    <div className="spaces mt-12 border-table custom-table">
      <OctTable
        id="table-tt-ke-hoach"
        className={`spaces custom-header-table ${isView ? 'table-view-tt-ke-hoach' : 'table-tt-ke-hoach'}`}
        columns={columns[type.code]}
        data={dsKeHoach}
        noToolbar
        clearToolbar
        noPagination
        fixedColumnsCount={-1}
      />
    </div>
  );
};

export default TableThongTinKyThuatChuyenGiao;
